import React from "react";
import { FaWifi, FaPhoneAlt, FaTv, FaShieldAlt, FaLaptopCode, FaBriefcase } from "react-icons/fa";
import { useInView } from "../../../hooks/useInView";
import SkeletonCard from "../../../components/SkeletonCard/SkeletonCard";

const HomeTwoIndustries = () => {
  const [ref, isInView] = useInView({ threshold: 0.1 });

  const industries = [
    {
      icon: <FaWifi />,
      title: "Internet Providers",
      description: "Fiber, Cable, DSL",
      color: "blue-2-color"
    },
    {
      icon: <FaPhoneAlt />,
      title: "Voice & Small Business",
      description: "Business phone solutions",
      color: "green-4-color"
    },
    {
      icon: <FaTv />,
      title: "TV Providers",
      description: "DIRECTV and streaming",
      color: "pink-color"
    },
    {
      icon: <FaShieldAlt />,
      title: "Home Security",
      description: "Smart home solutions",
      color: "orange-color"
    },
    {
      icon: <FaLaptopCode />,
      title: "SMB Technology",
      description: "Tech solutions for businesses",
      color: "blue-2-color"
    },
    {
      icon: <FaBriefcase />,
      title: "Service-Based Businesses",
      description: "Legal, Real Estate & more",
      color: "green-4-color"
    },
  ];

  return (
    <>
      <section ref={ref} className="achievement__area pt-115 pb-90 glassmorphic-section">
        <div className="container">
          <div className="row">
            <div className="col-xl-8 offset-xl-2">
              <div className="section__title section__title-3 text-center mb-55">
                <span>Our Expertise</span>
                <h2>Industries We Serve</h2>
              </div>
            </div>
          </div>
          <div className="row">
            {!isInView ? (
              // Show skeleton loaders while not in view
              Array.from({ length: 6 }).map((_, index) => (
                <div key={index} className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                  <SkeletonCard type="achievement" />
                </div>
              ))
            ) : (
              // Show actual content when in view
              industries.map((industry, index) => (
                <div
                  key={index}
                  className="col-xl-4 col-lg-4 col-md-6 col-sm-12"
                >
                  <div className="achievement__item text-center mb-30 content-loaded">
                    <div className="achievement__icon mb-20">
                      <i className={industry.color} style={{ fontSize: '48px' }}>
                        {industry.icon}
                      </i>
                    </div>
                    <h3>{industry.title}</h3>
                    <p>{industry.description}</p>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default HomeTwoIndustries;
